import { ReduxConstants } from "utils/constants";
import { RootActionType } from "models/actionTypes/rootActionTypes";
import { ListState } from "models/stateTypes/listState";
import { ListActionType } from "models/actionTypes/listActionTypes";

const initialState: ListState = {};

export const listReducer = (state: ListState = initialState, action: ListActionType | RootActionType): ListState => {
  switch (action.type) {
    case ReduxConstants.RootActions.RESET:
      return initialState;
    case ReduxConstants.ListActions.SET_LIST_NAVIGATION:
      return action.payload;
    case ReduxConstants.ListActions.LOAD_ITEMS:
      return { ...state, navigationIds: action.payload.items, total: action.payload.total };
    case ReduxConstants.ListActions.SET_CURRENT_INDEX:
      return { ...state, indexToOpen: action.payload.index, pageToOpen: action.payload.page };
    default:
      return state;
  }
};
